import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ScaleIcon from 'mdi-react/ScaleBalanceIcon';
import { layout } from '@prisjakt/ui-base';
import { colors } from '@prisjakt/ui-base/styles/variables';
import { CheckboxInput } from '@prisjakt/ui-inputs';

const selectionColor = colors.yellow3;

const CompareIcon = styled(ScaleIcon)``;

const SelectBox = styled.label`
  display: flex;
  flex-direction: ${props => (props.vertical ? 'column' : 'row')};
  align-items: center;
  background: ${props => (props.selected ? selectionColor : colors.white)};
  border: 1px solid ${selectionColor};
  border-radius: ${layout.borderRadius};
  padding: 0.3rem;

  ${CompareIcon} {
    margin-right: ${props => (props.vertical ? '0' : '5px')};
    margin-bottom: ${props => (props.vertical ? '5px' : '0')};
  }
`;

const ProductCheckbox = ({
  className,
  vertical,
  selected,
  onSelect,
  onDeselect,
  ...props
}) => (
  <SelectBox
    className={className}
    vertical={vertical}
    selected={selected}
    {...props}
  >
    <CompareIcon size="16px" />
    <CheckboxInput
      onChange={e => (e.target.checked ? onSelect() : onDeselect())}
      checked={selected}
      tabIndex="0"
    />
  </SelectBox>
);

const { string, func, bool } = PropTypes;

ProductCheckbox.propTypes = {
  className: string,
  vertical: bool,
  selected: bool,
  onSelect: func,
  onDeselect: func,
};

const noop = () => {};

ProductCheckbox.defaultProps = {
  className: undefined,
  vertical: false,
  selected: false,
  onSelect: noop,
  onDeselect: noop,
};

export default ProductCheckbox;
